const FeatureLaunchNotification = ({
  title = '',
  description = '',
  ctaText = '',
  url = '',
  name = '',
  icon = '',
  v10Icon = '',
} = {}) => ({
  title: String(title),
  description: String(description),
  ctaText: String(ctaText),
  url: String(url),
  name: String(name),
  icon: String(icon),
  v10Icon: String(v10Icon),
});

export default FeatureLaunchNotification;

export type FeatureLaunchNotificationProps = ReturnType<typeof FeatureLaunchNotification>;
